import type {CompRef, Pointer} from '@wix/document-services-types'
import {createHookDefinition} from '../../utils/hooksUtils'
import type {HookEventData} from '../hooks/hooks'
import type {FeatureData} from '../features/features'
import type {DalItem} from '@wix/document-manager-core'

interface GetItemQueryIdData {
    compPointer: CompRef
    propName: string
}
interface FeatureDataUpdate {
    compPointer: Pointer
    featureName: string
    featureData: FeatureData
}

export interface GetQueryIdEvent extends GetItemQueryIdData, HookEventData<'get_query_id'> {}
export interface FeatureDataUpdatedEvent extends FeatureDataUpdate, HookEventData<'after_feature_data_update'> {}

interface BeforeGetRepeatedPointer {}

export interface ItemOptions {
    elementType?: string
    refTypes?: readonly string[]
    languageCode?: string
    skipOriginalNodeMerge?: boolean
    raw?: boolean
}

interface DeserializeDataItem {
    deserializedDataItem: DalItem
    itemType: string
    itemId: string
    oldToNewIdMap?: Record<string, string>
    options?: ItemOptions
}
export interface DeserializeDataItemAfterEvent
    extends DeserializeDataItem,
        HookEventData<'after_deserialize_data_item'> {}

interface SerializeDataItem {
    dataItem: DalItem
    namespace?: string
    options?: ItemOptions
}

interface SerializedFlatDataItem {
    serializedFlatDataItem: DalItem
    itemType: string
    itemId: string
    options?: ItemOptions
}

export interface BeforeGetRepeatedPointerEvent
    extends BeforeGetRepeatedPointer,
        HookEventData<'before_get_repeated_pointer'> {}

interface InnerElementDataUpdateBefore {
    componentPointer: CompRef
    dataItem: any
}
export interface InnerElementDataUpdateBeforeEvent
    extends InnerElementDataUpdateBefore,
        HookEventData<'inner_element_data_update_before'> {}

interface InnerElementDataUpdateAfter {
    componentPointer: CompRef
    dataItem: any
}
export interface InnerElementDataUpdateAfterEvent
    extends InnerElementDataUpdateAfter,
        HookEventData<'inner_element_data_update_after'> {}

interface DataUpdateBefore {
    componentPointer: Pointer
    dataItem: any
}
export interface DataUpdateBeforeEvent extends DataUpdateBefore, HookEventData<'data_update_before'> {}

interface DataUpdateAfter {
    componentPointer: Pointer
    dataItem: any
}
export interface DataUpdateAfterEvent extends DataUpdateAfter, HookEventData<'data_update_after'> {}

export const DATA_MODEL_HOOKS = {
    DATA: {
        UPDATE_BEFORE: createHookDefinition<'data_update_before', DataUpdateBefore>('data_update_before'),
        UPDATE_AFTER: createHookDefinition<'data_update_after', DataUpdateAfter>('data_update_after'),
        INNER_ELEMENT_UPDATE_AFTER: createHookDefinition<
            'inner_element_data_update_after',
            InnerElementDataUpdateAfter
        >('inner_element_data_update_after'),
        INNER_ELEMENT_UPDATE_BEFORE: createHookDefinition<
            'inner_element_data_update_before',
            InnerElementDataUpdateBefore
        >('inner_element_data_update_before')
    },
    NAMESPACE_ITEM: {
        GET_QUERY_ID: createHookDefinition<'get_query_id', GetItemQueryIdData>('get_query_id')
    },
    GET_REPEATED_ITEM_POINTER: {
        BEFORE: createHookDefinition<'before_get_repeated_pointer', BeforeGetRepeatedPointer>(
            'before_get_repeated_pointer'
        )
    },
    FEATURE_DATA_UPDATE: {
        AFTER: createHookDefinition<'after_feature_data_update', FeatureDataUpdate>('after_feature_data_update')
    },
    SERIALIZE: {
        DATA_ITEM_AFTER: createHookDefinition<'after_serialize_data_item', SerializeDataItem>(
            'after_serialize_data_item'
        )
    },
    DESERIALIZE: {
        DATA_ITEM_NEST_BEFORE: createHookDefinition<'nest_before_deserialize_data_item', SerializedFlatDataItem>(
            'nest_before_deserialize_data_item'
        ),
        DATA_ITEM_AFTER: createHookDefinition<'after_deserialize_data_item', DeserializeDataItem>(
            'after_deserialize_data_item'
        )
    }
}
